export default "__VITE_ASSET__uwAzsJus__"